import { iconFactory } from '../iconFactory'

export const Buildings = iconFactory(
  'Buildings',
  ({ fill }) => (
    <path
      d="M8.00016 4.66667V2H1.3335V14H14.6668V4.66667H8.00016ZM4.00016 12.6667H2.66683V11.3333H4.00016V12.6667ZM4.00016 10H2.66683V8.66667H4.00016V10ZM4.00016 7.33333H2.66683V6H4.00016V7.33333ZM4.00016 4.66667H2.66683V3.33333H4.00016V4.66667ZM6.66683 12.6667H5.3335V11.3333H6.66683V12.6667ZM6.66683 10H5.3335V8.66667H6.66683V10ZM6.66683 7.33333H5.3335V6H6.66683V7.33333ZM6.66683 4.66667H5.3335V3.33333H6.66683V4.66667ZM13.3335 12.6667H8.00016V11.3333H9.3335V10H8.00016V8.66667H9.3335V7.33333H8.00016V6H13.3335V12.6667ZM12.0002 7.33333H10.6668V8.66667H12.0002V7.33333ZM12.0002 10H10.6668V11.3333H12.0002V10Z"
      fill={fill}
    />
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
